var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"user-administration"},[_c('h2',{staticClass:"title is-2"},[(this.$route.name !== 'userlist')?_c('router-link',{attrs:{"to":{ name: 'userlist' }}},[_vm._v("Userverwaltung")]):[_vm._v("Userverwaltung")]],2),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }